export type FHPlayer = {
  id: number
  famePoints: number
}

export type FHGame = {
  id: number
  date: string
  winnerId: number
  loserId?: number
}

// ELO-style coefficient: 0.1 means defeating a 100-point-higher opponent gives +10 bonus
const C = 0.1

export const calculateFamePoints = ({
  player1,
  player2,
  winner,
  gamesOfBattleHistory,
  gamesOfPlayer1Today,
  gamesOfPlayer2Today,
  isInAuthorizedOfflinePlace,
  isRecommendedBySystem,
}: {
  gameId?: number
  player1: FHPlayer
  player2: FHPlayer
  winner: FHPlayer
  gamesOfBattleHistory: FHGame[]
  gamesOfPlayer1Today: FHGame[]
  gamesOfPlayer2Today: FHGame[]
  isInAuthorizedOfflinePlace?: boolean
  isRecommendedBySystem?: boolean
}): {
  winnerId: number
  oldFamePoints: number
  newFamePoints: number
  opponentPoints: number
  winnerTodayGamesCount: number
  gamesOfBattleHistoryCount: number
  isInAuthorizedOfflinePlace: boolean
  isRecommendedBySystem: boolean
  paramB: number
  paramG: number
  paramR: number
} => {
  // DIAGNOSTIC: Log all input values to debug fame calculation
  console.log(`[Fame-DEBUG] calculateFamePoints INPUT:`, {
    player1Id: player1.id,
    player1Fame: player1.famePoints,
    player2Id: player2.id,
    player2Fame: player2.famePoints,
    winnerId: winner.id,
    winnerFame: winner.famePoints,
    battleHistoryLength: gamesOfBattleHistory.length,
    isInAuthorizedOfflinePlace,
  })

  const loserId = winner.id === player1.id ? player2.id : player1.id
  const winnedGamesVsOpponent = gamesOfBattleHistory.filter(x => x.winnerId === winner.id && x.loserId === loserId)

  console.log(`[Fame-DEBUG] History analysis:`, {
    loserId,
    winnedGamesVsOpponentCount: winnedGamesVsOpponent.length,
    todayGamesCount: (winner.id === player1.id ? gamesOfPlayer1Today : gamesOfPlayer2Today).length
  })

  const gamesOfToday = winner.id === player1.id ? gamesOfPlayer1Today : gamesOfPlayer2Today
  const winnerPoints = winner.famePoints
  const loserPoints = winner.id === player1.id ? player2.famePoints : player1.famePoints

  const oldFamePoints = winner.famePoints || 0
  let newFamePoints = oldFamePoints

  let paramB = 0
  let paramG = 0


  if (gamesOfToday.length <= 5) {
    if (isRecommendedBySystem) {
      paramB = 0
    } else if (isInAuthorizedOfflinePlace) {
      paramB = 100
    } else if (winnedGamesVsOpponent.length === 0) {
      paramB = 100
    } else {
      paramB = Math.max(1, 10 - winnedGamesVsOpponent.length)
    }

    const offset = loserPoints - winnerPoints
    const wins = winnedGamesVsOpponent.length
    const G = 1 + Math.pow(wins, 2)
    paramG = Math.round(Math.max(0, (C * offset) / G))
  }

  const paramR = paramB + paramG
  newFamePoints = newFamePoints + paramR

  return {
    winnerId: winner.id,
    oldFamePoints,
    paramB,
    paramG,
    paramR,
    newFamePoints,
    opponentPoints: loserPoints,
    winnerTodayGamesCount: gamesOfToday.length,
    gamesOfBattleHistoryCount: gamesOfBattleHistory.length,
    isInAuthorizedOfflinePlace: !!isInAuthorizedOfflinePlace,
    isRecommendedBySystem: !!isRecommendedBySystem,
  }
}

